import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { isDesktop } from "react-device-detect";
import FingerprintJS from "@fingerprintjs/fingerprintjs-pro";
import { Icon } from "@iconify/react";
import Skeleton from "react-loading-skeleton";
// import Swal from "sweetalert2";

//Components
import Sidebar from "../../components/Sidebar/Sidebar";
import QuickPay from "./QuickPay";
import BankTransfer from "./BankTransfer";
import EWallet from "./EWallet";
import MobileDeposit from "./MobileDeposit";
import Crypto from "./Crypto";
import { Modal } from "react-responsive-modal";
//Actions
import * as actions from "../../store/ducks/deposit/actions";
import { getWallet } from "../../store/ducks/wallet/actions";
import { storedDepositDropdownValidation, storedSecretPayBankOptionsValidation } from "../../common/config/depositDataValidation";

const exclude_transaction_options = ['quick-pay', 'e-wallet', 'crypto'];
class Deposit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            depositOption: "",
            transactionChannel: [],
            transactionChannelId: "",
            loading: true,

            bankOfflineMin: 0,
            bankOfflineMax: 0,
            paymentTypeId: "",
            paymentGatewaySelected: "",
            cryptoChannel: "",
            cryptoType: "",
            channelId: "",
            paymentGateway: [],
            bankOfflineFees: 0,
            depositEstTime: "00:00:00",

            platform: "",
            bankTransferPaymentTypeId: {}, // use to store payment_type_id for bank-transfer (online_banking, secret_pay_offline)
            data: [],
            showNum: false,
            showModal: false,
        };
    }

    componentDidMount() {
        this.props.funcGetDropDown();
        this.props.funcGetWallet();

        let data = {};
        data.transType = "deposit";
        data.currencyCode = this.props.currentUser.currency;
        this.props.funcGetSecretPayBankOption(data);

        //Fingerprint
        const fpPromise = FingerprintJS.load({
            apiKey: process.env.REACT_APP_FINGERPRINT_ID,
        });

        // Get the visitor identifier when you need it.
        fpPromise
            .then((fp) => fp.get({ extendedResult: true }))
            .then((result) => {
                this.setState({
                    platform: result.browserName,
                });
            });
    }

    shouldComponentUpdate(nextProps, nextState) {
        // const { t } = this.props;
        if (nextProps.bank_offline_option !== this.props.bank_offline_option) {
            let to_store_data = storedSecretPayBankOptionsValidation(this.props.default_secretpay_bank_offline_options, nextProps.bank_offline_option.data);
            if (to_store_data.overwrite === true) {
                const storeOfflineOptions = {};
                storeOfflineOptions.data = nextProps.bank_offline_option.data;
                this.props.funcDefaultBankOfflineOptions(storeOfflineOptions);
            }
        }

        if (nextProps.dropDown !== this.props.dropDown && nextProps.dropDown !== undefined) {
            if (nextProps.dropDown.responseCode === 200 && nextProps.dropDown.msgType === "success") {
                let depositOption = this.state.depositOption;
                let transactionChannelId = this.state.transactionChannelId;
                let bankTransferPaymentTypeId = {};

                let filteredTransactionChannel = nextProps.dropDown.data.transaction_channel.filter((val) => !exclude_transaction_options.includes(val.slug));
                filteredTransactionChannel.forEach((val) => {
                    if (val.dp_status === 1 && depositOption === "") {
                        depositOption = depositOption === "" && val.dp_status === 1 ? val.slug : depositOption;
                        transactionChannelId = val.id;
                    }
                });

                let paymentTypeId = "";
                let paymentGatewaySelected = "";
                let cryptoType = "";
                let cryptoChannel = "";
                let channelId = "";

                if (depositOption === "bank-transfer") {
                    nextProps.dropDown.data.payment_gateway.forEach((val, index) => {
                        if(val.transaction_slug === depositOption) {
                            if (paymentTypeId === "" && val.dp_status === 1) {
                                paymentTypeId = val["id"];
                                paymentGatewaySelected = val["slug"];
                            }
                            if (val.slug === "secret_pay_offline" && val.dp_status === 1) {
                                if (this.props.currentUser.country_id === 1) {
                                    let data = {};
                                    data.currencyCode = this.props.currentUser.currency;
                                    this.props.funcGetBankOfflineOptions(data);

                                    this.setState({
                                        bankOfflineMin: val.transaction_minimum_payment_amount,
                                        bankOfflineMax: val.transaction_maximum_payment_amount,
                                        paymentTypeId: val.id,
                                        bankOfflineFees: val.fees,
                                    });
                                }
                            }
                            bankTransferPaymentTypeId[val.slug] = val.id;
                        }
                    });
                }

                if (depositOption === "quick-pay") {
                    nextProps.dropDown.data.payment_gateway.map((val) => {
                        if (val.transaction_slug === "quick-pay" && val.dp_status === 1) {
                            if (paymentTypeId === "") {
                                paymentTypeId = val["id"];
                                paymentGatewaySelected = val["slug"];
                            }
                        }
                    });
                }

                if (depositOption === "e-wallet") {
                    nextProps.dropDown.data.payment_gateway.map((val) => {
                        if (val.transaction_slug === "e-wallet" && val.dp_status === 1) {
                            if (paymentTypeId === "") {
                                paymentTypeId = val["id"];
                                paymentGatewaySelected = val["slug"];
                            }
                        }
                    });
                }

                if(depositOption === "crypto"){
                    nextProps.dropDown.data.payment_gateway.map((val) => {
                        if (val.transaction_slug === "crypto" && val.slug_details === "crypto-vendor" && val.dp_status === 1) {
                            if (paymentTypeId === "") {
                                paymentTypeId = val["id"];
                                paymentGatewaySelected = val["slug"];
                            }
                        }

                        else if (val.transaction_slug === "crypto" && val.dp_status === 1) {
                            if (channelId === "") {
                                channelId = val["id"];
                                cryptoType = val['slug_details'];
                                cryptoChannel = val['slug'];
                            }
                        }
                    });
                }

                this.setState({
                    depositOption: depositOption,
                    transactionChannel: filteredTransactionChannel,
                    transactionChannelId: transactionChannelId,
                    paymentTypeId: paymentTypeId,
                    paymentGatewaySelected: paymentGatewaySelected,
                    paymentGateway: nextProps.dropDown.data.payment_gateway,
                    cryptoChannel: cryptoChannel,
                    bankTransferPaymentTypeId,
                    channelId: channelId,
                    cryptoType: cryptoType,
                    loading: false
                });

                // store dropdown option for all the transaction channel
                let to_store_data = storedDepositDropdownValidation(this.props.default_dropdown_options, nextProps.dropDown.data);
                if (to_store_data.overwrite === true) {
                    const storeDropdown = {};
                    storeDropdown.data = nextProps.dropDown.data;
                    this.props.funcDefaultDropDownOptions(storeDropdown);
                }
            }
        }

        if (nextProps.bank_option !== this.props.bank_option) {
            if (nextProps.bank_option.responseCode === 200) {
                let to_store_data = storedSecretPayBankOptionsValidation(this.props.default_secretpay_bank_options, nextProps.bank_option.data);
                if (to_store_data.overwrite === true) {
                    const storeBankOptions = {};
                    storeBankOptions.data = nextProps.bank_option.data;
                    this.props.funcDefaultSecretPayBankOptions(storeBankOptions);
                }
            }
        }

        if(nextProps.get_wallet !== undefined && nextProps.get_wallet !== this.props.get_wallet){
            if(nextProps.get_wallet.responseCode === 200 && nextProps.get_wallet.msgType === 'success'){
                this.setState({
                    data: nextProps.get_wallet.data.result
                });
            }
        }

        return true;
    }

    optionSelectHandler = (e, option, optionId, depositEstTime) => {
        e.preventDefault();
        let date = new Date();

        // Temporary hide for phase 2 only implement
        // if (option === "crypto") {
        //     this.props.funcGetAvailableCrypto();

        //     const cryptoData = {};
        //     cryptoData.crypto = "USDT";

        //     this.props.funcGetCrypto(cryptoData);
        // }

        let paymentTypeId = "";
        let paymentGatewaySelected = "";

        let bankTransferPaymentTypeId = {};
        let bankOfflinePaymentGatewaySelected = "";
        let bankOfflineMin = 0;
        let bankOfflineMax = 0;
        let bankOfflineFees = 0;

        let cryptoType = "";
        let cryptoChannel = "";
        let channelId = "";

        if (option === "quick-pay") {
            this.state.paymentGateway.map((val) => {
                if (val.transaction_slug === "quick-pay" && val.dp_status === 1) {
                    if (paymentTypeId === "") {
                        paymentTypeId = val["id"];
                        paymentGatewaySelected = val["slug"];
                    }
                }
            });
        }

        if (option === "bank-transfer") {
            this.state.paymentGateway.map((val, index) => {
                if(val.transaction_slug === option){
                    if (paymentTypeId === "" && val.dp_status === 1) {
                        paymentTypeId = val["id"];
                        paymentGatewaySelected = val["slug"];
                    }
                    if (val.slug === "secret_pay_offline" && val.dp_status === 1) {
                        let data = {};
                        data.currencyCode = this.props.currentUser.currency;
                        this.props.funcGetBankOfflineOptions(data);

                        bankOfflineMin = val["transaction_minimum_payment_amount"];
                        bankOfflineMax = val["transaction_maximum_payment_amount"];
                        bankOfflineFees = val["fees"];
                        bankOfflinePaymentGatewaySelected = val["slug"];
                    } else if (val.slug === "online_banking" && val.dp_status === 1) {
                        bankOfflinePaymentGatewaySelected = val["slug"];
                    }
                    bankTransferPaymentTypeId[val.slug] = val.id;
                }
            });
        }

        if(option === "crypto"){
            this.state.paymentGateway.map((val) => {
                if (val.transaction_slug === option) {
                    if (paymentTypeId === "" && val.dp_status === 1) {
                        paymentTypeId = val["id"];
                        paymentGatewaySelected = val["slug"];
                    }

                    if (channelId === "" && val.dp_status === 1) {
                        channelId = val["id"];
                        cryptoType = val['slug_details'];
                        cryptoChannel = val['slug'];
                    }
                }
            });
        }

        this.setState({
            depositOption: this.props.depositOption !== option ? option : "",
            transactionChannelId: optionId,
            paymentTypeId: paymentTypeId,
            paymentGatewaySelected: paymentGatewaySelected,
            bankOfflinePaymentGatewaySelected: bankOfflinePaymentGatewaySelected,
            bankTransferPaymentTypeId: bankTransferPaymentTypeId,
            bankOfflineMin: bankOfflineMin,
            bankOfflineMax: bankOfflineMax,
            bankOfflineFees: bankOfflineFees,
            cryptoChannel: cryptoChannel,
            channelId: channelId,
            cryptoType: cryptoType,
            depositEstTime: depositEstTime
        });
    };

    redirectHandler = () => {
        this.props.history.push({
            pathname: "/transaction-report",
            state: {
                historyTab: "deposit",
                defaultTab: 0,
            },
        });
    };

    onInputChangeHandler = (event) => 
	{
        // console.log(event.target.name+' | '+event.target.value)
		if (event.target.name === 'showNum') 
        {
            this.setState({
                showNum: !this.state.showNum,
                errorMsg: [],
                formError: false,
                converted_currency: "",
                converted_amount: "",
            });
        }
        else 
        {
            this.setState({
                [event.target.name]: event.target.value,
                errorMsg: [],
                formError: false,
                converted_currency: "",
                converted_amount: ""
            });
        }

        if(event.target.name === 'amount'){
            if(this.state.memberId !== null && this.state.memberId !== "" && this.state.memberId !== undefined && event.target.value > 0){
                let data = {};
                data.member_id = this.state.memberId;
                data.amount = event.target.value;
                this.props.getCurrencyExchange(data);
            }
        }
	};
    
    toggleModal = () => 
    {
        this.setState({
            showModal: !this.state.showModal,
        });
    };

    imageImport = (r) => {
        let images = {};
        r.keys().map((item, index) => {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    };

    render() {
        const { t } = this.props;
        let transactionChannel = this.state.transactionChannel ? this.state.transactionChannel : [];
        const icons = this.imageImport(require.context("../../assets/images/deposit/icons", false, /\.(png|jpe?g|svg)$/));
        const img = this.imageImport(require.context("../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/));
        let date = new Date();
        return (
            <Auxiliary>
             <Modal open={this.state.showModal} onClose={this.toggleModal} classNames={{ modal: "pd-edit-modal" }} center>
                <div className={!isDesktop ? "modal-content edit" : "edit"}>
                <div className="modal-header">
                    <h4 className="modal-title mb-3">{t('deposit.notice')}</h4>
                </div>
                <div className="modal-body">
                        <ol className="px-3">
                        <li className="mb-2">{t('deposit.deposit-notice-content-1')}</li>
                        <li className="mb-2">{t('deposit.deposit-notice-content-2')}</li>
                        <li className="mb-2"><span>{t('deposit.deposit-notice-content-title-3')}</span> {t('deposit.deposit-notice-content-3')}</li>
                        <li className="mb-2">{t('deposit.deposit-notice-content-4')}<span>{t('deposit.deposit-notice-content-title-4')}</span>{t('deposit.deposit-notice-content-4-cont')}</li>
                        <li className="mb-2">{t('deposit.deposit-notice-content-5')}</li>
                        <li className="mb-2">{t('deposit.deposit-notice-content-6')}<a href="/" onClick={window['liveChatButton']}>{t('deposit.deposit-notice-content-title-6')}</a>{t('deposit.deposit-notice-content-6-cont')}</li>
                        </ol>
                    {isDesktop && (
                        <button className="btn btn-gradient-blue w-50 d-block mx-auto mt-4" onClick={this.toggleModal}>
                            {t('global.ok')}
                        </button>
                    )}
                </div>
                {!isDesktop && (
                    <div class="modal-footer" onClick={this.toggleModal}>
                        <button className="btn modal-btn-confirm ">{t('global.ok')}</button>
                    </div>
                )}
                </div>

                {!isDesktop && (
                    <div className="modal-m-close-btn" onClick={this.toggleModal}>
                        <p className="modal-close-btn">{t('global.close')}</p>
                    </div>
                )}
            </Modal>

                {isDesktop ? (
                    <section className="pf-dashboard">
                        <div className="x-container">
                            <Sidebar />
                            <div className="row">
                                <div className="col-12">
                                    <div className="pd-card-col d-flex flex-column h-100">
                                    <div className="pd-header mb-3">
                                        <h4 className="mb-0"> {t("profile-sidebar.deposit")}</h4>
                                        <button className="btn">
                                                <Icon icon="material-symbols:info" onClick={this.toggleModal} />
                                            </button>
                                            </div>
                                        <div className="my-wallet-col mb-3">
                                                    <div className="row g-3">
                                                        <div className="col-6">
                                                            <div className="quota-deposit-container ">
                                                            <div className="available-amount-content">
                                                                    <img className="active" src={icons["wallet-ico.svg"]} alt="wallet-ico" />
                                                                    <div className="amount-body w-100">
                                                                   
                                                                        <label>{t("wallet.wallet")}</label>
                                                                        {this.state.loading ? (
                                                                                <Skeleton count={1} height={20} />
                                                                            ) : (
                                                                        <div className="amount">
                                                                           {this.state.showNum ? 
                                                                                <p>
                                                                                {this.props.currentUser.currency}
                                                                                <span className="ms-2">
                                                                                    {Intl.NumberFormat("en-US", { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(this.state.data)}
                                                                                </span>
                                                                                </p>
                                                                                : 
                                                                                    '*******'} 
                                                                        <img
                                                                            className="show-hide-btn"
                                                                            src={img[`${(!this.state.showNum) ? 'close-' : ''}eye.png`]}
                                                                            alt="hide pwd"
                                                                            id="showNum"
                                                                            name="showNum"
                                                                            onClick={(event) => this.onInputChangeHandler(event)}
                                                                        />
                                                                    </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <small className="text-danger">
                                                <Icon icon="material-symbols:info" /> {t('deposit.note')}
                                                </small>
                                        <div className="pd-content mb-3">
                                            {this.state.loading ? (
                                                <Skeleton count={4} height={50} style={{marginBottom: "1rem"}} />
                                            ) : (
                                            <div className="d-grid gap-3">
                                                <div>
                                                    <label className="col-form-label">{t("deposit.deposit-option")}:</label>
                                                    <div className="mb-3 select-bank-opts d-flex flex-wrap">
                                                        {transactionChannel.map((val, idx) => {
                                                            if (val.dp_status === 1) {
                                                                return (
                                                                    <div
                                                                        className="form-check form-check-inline"
                                                                        onClick={(event) => this.optionSelectHandler(event, val.slug, val.id)}
                                                                        key={idx}
                                                                    >
                                                                        <input
                                                                            className="btn-check"
                                                                            type="radio"
                                                                            name="depositOption"
                                                                            id={`deposit${val.slug}`}
                                                                            value={val.slug}
                                                                            onChange={() => {}}
                                                                            checked={this.state.depositOption === val.slug ? true : false}
                                                                        />
                                                                        <label className="btn form-check-label square-label" htmlFor={`deposit${val.slug}`}>
                                                                            <img src={icons[`${val.slug}.svg`]} alt={val.slug} />
                                                                            <p>{t(`transaction-channel.${val.slug}`)}</p>
                                                                            {/* {process.env.REACT_APP_ENV === "staging" && val.deposit_est_time && (
                                                                                    <div className="transfer-duration">
                                                                                        <Icon icon="ic:baseline-alarm" />
                                                                                        Deposit in 1 min
                                                                                        {val.deposit_est_time === "00:00:00" ? (
                                                                                            <>
                                                                                                <Icon icon="ant-design:thunderbolt-outlined" />
                                                                                                {t("deposit.instant-deposit")}
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                <Icon icon="ic:baseline-alarm" />
                                                                                                   {new Date(date.getMonth() + date.getDate() + "," + val.deposit_est_time).getSeconds() > 0 ? (
                                                                                                        <>
                                                                                                            {t("deposit.deposit-in", { minute: new Date(date.getMonth() + date.getDate() + "," + val.deposit_est_time).getSeconds() })} {t("deposit.sec")}
                                                                                                       </>
                                                                                                   ) : (
                                                                                                        <>
                                                                                                            {t("deposit.deposit-in", { minute: new Date(date.getMonth() + date.getDate() + "," + val.deposit_est_time).getMinutes() })} {t("deposit.minute")}
                                                                                                        </>
                                                                                                   )}
                                                                                            </>
                                                                                        )}
                                                                                        
                                                                                    </div>
                                                                                    
                                                                                )} */}
                                                                        </label>
                                                                    </div>
                                                                    
                                                                );
                                                            }
                                                            
                                                            // else
                                                            // {
                                                            return null;
                                                            // }
                                                        })}
                                                    </div>
                                                    {/* {this.state.depositOption === "quick-pay" ? (
                                                        <QuickPay redirectHandler={this.redirectHandler} {...this.state} />
                                                    ) : this.state.depositOption === "bank-transfer" ? (
                                                        <BankTransfer redirectHandler={this.redirectHandler} {...this.state} />
                                                    ) : this.state.depositOption === "e-wallet" ? (
                                                        <EWallet redirectHandler={this.redirectHandler} {...this.state} />
                                                    ) : this.state.depositOption === "crypto" ? (
                                                        <Crypto redirectHandler={this.redirectHandler} {...this.state} />
                                                    ) : (
                                                        <></>
                                                    )} */}
                                                    {this.state.depositOption === "bank-transfer" ? (
                                                        <BankTransfer redirectHandler={this.redirectHandler} {...this.state} />
                                                    ): (
                                                        <></>
                                                    )} 
                                                </div>
                                            </div>
                                           )}
                                        </div>
                                        <div className="payment-notices-col">
                                            <h6>{t("deposit.notice")}</h6>
                                            <ol>
                                                <li>{t("deposit.deposit-notice-content-1")}</li>
                                                <li>{t("deposit.deposit-notice-content-2")}</li>
                                                <li>
                                                    <span>{t("deposit.deposit-notice-content-title-3")}</span> {t("deposit.deposit-notice-content-3")}
                                                </li>
                                                <li>
                                                    {t("deposit.deposit-notice-content-4")}
                                                    <span>{t("deposit.deposit-notice-content-title-4")}</span>
                                                    {t("deposit.deposit-notice-content-4-cont")}
                                                </li>
                                                <li>{t("deposit.deposit-notice-content-5")}</li>
                                                <li>
                                                    {t("deposit.deposit-notice-content-6")}
                                                    <a href="/" onClick={window["liveChatButton"]}>
                                                        {t("deposit.deposit-notice-content-title-6")}
                                                    </a>
                                                    {t("deposit.deposit-notice-content-6-cont")}
                                                </li>
                                            </ol>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                ) : (
                    <MobileDeposit
                        optionSelectHandler={this.optionSelectHandler}
                        redirectHandler={this.redirectHandler}
                        toggleModal={this.toggleModal}
                        transactionChannel={transactionChannel}
                        {...this.state}
                        {...this.props}
                    />
                )}
            </Auxiliary>
        );
    }
}

//Received the response from the redux calling the api response
const mapStateToProps = (state) => {
    return {
        dropDown: state.deposit.dropDown,
        currentUser: state.currentUser.data,
        bank_option: state.deposit.bank_option,
        default_dropdown_options: state.deposit.default_dropdown_options,
        default_secretpay_bank_options: state.deposit.default_secretpay_bank_options,
        bank_offline_option: state.deposit.bank_offline_option,
        default_secretpay_bank_offline_options: state.deposit.default_secretpay_bank_offline_options,
        get_wallet: state.wallet.get_wallet,
    };
};

//Using the redux calling api methods
const mapDispatchToProps = (dispatch) => {
    return {
        funcGetDropDown: () => dispatch(actions.getDropDown()),
        funcGetSecretPayBankOption: (data) => dispatch(actions.getSecretPayBankOption(data)),
        funcGetBankOfflineOptions: (data) => dispatch(actions.getSecretPayBankOfflineOption(data)),
        funcDefaultDropDownOptions: (data) => dispatch(actions.defaultDropDownOptions(data)),
        funcDefaultSecretPayBankOptions: (data) => dispatch(actions.defaultSecretPayBankOptions(data)),
        funcDefaultBankOfflineOptions: (data) => dispatch(actions.defaultSecretPayBankOfflineOptions(data)),
        funcGetWallet: () => dispatch(getWallet())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(Deposit));
